import React, { useState } from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import {
  FaCalendarCheck,
  FaUser,
  FaReceipt,
  FaBars, // Toggle Button
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { ImList2 } from "react-icons/im";



const ClientSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <>
      <div style={{ display: "flex", height: "10  0vh" }}>
        {/* Sidebar */}
        <Sidebar collapsed={collapsed} width="200px">
          <Menu>
            {/* Sidebar Header with Toggle Button */}
            <div className="sidebar-header">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "12px",
                }}
              >
                <FaBars
                  className="toggle-btn"
                  style={{ color: "black" }}
                  onClick={() => setCollapsed(!collapsed)}
                />

              </div>
            </div>

            {/* General Section */}
            <MenuItem
              component={<Link to="/client/ClientDashboard" />}
              icon={<MdDashboard />}
            >
              Dashboard
            </MenuItem>
            <MenuItem
              component={<Link to="/client/ClientProfile" />}
              icon={<FaUser />}
            >
              Profile
            </MenuItem>
            <MenuItem
              component={<Link to="/client/ClientCounsellorList" />}
              icon={<ImList2 />}
            >
              Counsellors
            </MenuItem >
            <MenuItem
              component={<Link to="/client/ClientReceipt" />}
              icon={<FaReceipt />}
            >
              Receipt
            </MenuItem>
          </Menu>
        </Sidebar>
      </div>{" "}
    </>
  );
};

export default ClientSidebar;
